import React, { memo } from "react"
import { Box } from "@material-ui/core"
import { themePalette } from "./styles"
import LeftPanelFilters from "./LeftPanelFilters"
import VirtualizedMetersList from "./VirtualizedMetersList"

// Panel izquierdo de la pantalla.
// Coordina filtros y lista, pero deja el detalle de cada responsabilidad en subcomponentes.
function LeftPanel(props) {
  const { isMobile, mobileView } = props

  return (
    <Box
      sx={{
        flex: isMobile ? "0 0 100%" : "0 0 50%",
        minWidth: 0,
        maxWidth: isMobile ? "100%" : "50%",
        boxSizing: "border-box",
        backgroundColor: themePalette.surface.panel,
        display: isMobile && mobileView !== "list" ? "none" : "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <LeftPanelFilters {...props} />
      <VirtualizedMetersList {...props} />
    </Box>
  )
}

export default memo(LeftPanel)
